import React from 'react'
import { Layout, ItemTitle, Header, SectionTitle } from '../../../../components'

import './style.scss'
import data from './data.json'
import changelog from '../../../../data/changelog.json'

export default () => {
  return (
    <>
      <Header
        title={data.title}
        site={data.site}
        state="design"
        slug="utilities/type-style/design/"
      />
      <Layout
        updated={changelog[data.title].lastUpdated}
        title={data.title}
        category={data.category}
        description={data.description}
        state="design"
        site={data.site}
        changelog={changelog[data.title].changelog}
        slug="utilities/type-style/design/"
      >
        <SectionTitle>Style Options</SectionTitle>
        <ItemTitle>Type Alignment</ItemTitle>

        <div className="type-style__showcase">
          <div class="type-style__item left"></div>
          The quick brown fox jumps over the lazy dog.
        </div>
        <div className="type-style__name">Left Alignment</div>

        <div className="type-style__showcase u-type--center">
          <div class="type-style__item center "></div>
          The quick brown fox jumps over the lazy dog.
        </div>
        <div className="type-style__name">Center Alignment</div>

        <div className="type-style__showcase u-type--right">
          <div class="type-style__item right "></div>
          The quick brown fox jumps over the lazy dog.
        </div>
        <div className="type-style__name">Right Alignment</div>

        <ItemTitle class="l-margin-top--xxxlarge">Type Scale</ItemTitle>

        <table className="type-scale">
          <tbody>
            <tr>
              <td width="150px">XXSmall</td>
              <td className="u-type--xxsmall">
                The five boxing wizards jump quickly.
              </td>
            </tr>
            <tr>
              <td>XSmall</td>
              <td className="u-type--xsmall">
                The five boxing wizards jump quickly.
              </td>
            </tr>
            <tr>
              <td>Small</td>
              <td className="u-type--small">
                The five boxing wizards jump quickly.
              </td>
            </tr>
            <tr>
              <td>Medium</td>
              <td className="u-type--medium">
                The five boxing wizards jump quickly.
              </td>
            </tr>
            <tr>
              <td>Large</td>
              <td className="u-type--large">
                The five boxing wizards jump quickly.
              </td>
            </tr>
            <tr>
              <td>XLarge</td>
              <td className="u-type--xlarge">
                The five boxing wizards jump quickly.
              </td>
            </tr>
            <tr>
              <td>XXLarge</td>
              <td className="u-type--xxlarge">
                The five boxing wizards jump quickly.
              </td>
            </tr>
            <tr>
              <td>XXXLarge</td>
              <td className="u-type--xxxlarge">
                The five boxing wizards jump quickly.
              </td>
            </tr>
          </tbody>
        </table>

        <ItemTitle class="l-margin-top--xxxlarge">Type Decoration</ItemTitle>

        <table className="type-scale">
          <tbody>
            <tr>
              <td width="150px">Light</td>
              <td className="u-type--light">
                The five boxing wizards jump quickly.
              </td>
            </tr>
            <tr>
              <td>Normal</td>
              <td className="u-type--normal">
                The five boxing wizards jump quickly.
              </td>
            </tr>
            <tr>
              <td>Bold</td>
              <td className="u-type--bold">
                The five boxing wizards jump quickly.
              </td>
            </tr>
            <tr>
              <td>Italic</td>
              <td className="u-type--italic">
                The five boxing wizards jump quickly.
              </td>
            </tr>
            <tr>
              <td>Underline</td>
              <td className="u-type--underline">
                The five boxing wizards jump quickly.
              </td>
            </tr>
          </tbody>
        </table>
      </Layout>
    </>
  )
}
